export default "__VITE_ASSET__DqekeEt7__"